const borders = {
    none: 0,
    "0": "0",
    "1": "1px solid",
    "2": "2px solid",
};

export default borders;
